import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { setJSONLocalStorage, getJSONLocalStorage, getToken } from '../../functions/app_functions.js';
import withRouter from '../../with_router.js';
import ForminputText from '../forminput/forminput_text.js';
import ForminputTextbox from '../forminput/forminput_textbox.js';
import ForminputDate from '../forminput/forminput_date.js';
import ForminputDropdown from '../forminput/forminput_dropdown.js';
import ForminputPassword from '../forminput/forminput_password.js';
import Tripcarousel from './tripcarousel.js';
import Dashboard from './dashboard.js';
import Tripstatistics from './tripstatistics.js';
import Orders from './orders.js';
import MissingPage from '../error/missingpage.js';
import QRcode from './qrcode.js';
import { format_month_year } from '../../functions/functions_formatting.js';
import { ReactComponent as IconEdit } from '../../media/icons/edit.svg';
import { ReactComponent as IconLink } from '../../media/icons/arrow_right.svg';
import { ReactComponent as IconLocation } from '../../media/icons/location.svg';
import { ReactComponent as IconFacebook } from '../../media/icons/social_facebook.svg';
import { ReactComponent as IconYoutube } from '../../media/icons/social_youtube.svg';
import { ReactComponent as IconInstagram } from '../../media/icons/social_instagram.svg';
import { ReactComponent as IconTiktok } from '../../media/icons/social_tiktok.svg';
import { ReactComponent as IconSnapchat } from '../../media/icons/social_snapchat.svg';
import { ReactComponent as IconLinkedin } from '../../media/icons/social_linkedin.svg';
import { ReactComponent as IconTwitterx } from '../../media/icons/social_twitterx.svg';
import { ReactComponent as IconHome } from '../../media/icons/social_home.svg';
import { ReactComponent as IconAdd } from '../../media/icons/plus.svg';


class Account extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            user_id: null,
            login: null,
            page: "",
            uploading: false,
            upload_image_file: null,
            sample_picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/users/male.webp",
            data: {
                name: "",
                username: "",
                picture: {},
                bio_description: "",
                birthday: "",
                country: "",
                hometown: "",
                cities: [],
                locations: [],
                facebook: "",
                youtube: "",
                instagram: "",
                tiktok: "",
                linkedin: "",
                twitterx: "",
                snapchat: "",
                website: ""
            },
            userTrips: [],
            userOrders: [],
            userSales: [],
            userPayouts: [],
            userTripViews: [],
            userTripUnlocks: [],
            userReviews: [],
            current_balance: 0,
            email: "",
            password_old: "",
            password_new: "",
            password_new_2: "",
            trip_id: null
        };

        this.baseUrl = this.props.baseUrl;
        this.TRIP_THRESHOLD = 6;

        this.loadUserData = this.loadUserData.bind(this);
        this.loadUserTripData = this.loadUserTripData.bind(this);
        this.loadUserTripViewData = this.loadUserTripViewData.bind(this);
        this.loadUserTripUnlockData = this.loadUserTripUnlockData.bind(this);
        this.setPage = this.setPage.bind(this);
        this.setDataValue = this.setDataValue.bind(this);
        this.setFormValue = this.setFormValue.bind(this);
        this.addLocation = this.addLocation.bind(this);
        this.removeLocation = this.removeLocation.bind(this);
        this.addLocation = this.addLocation.bind(this);
        this.groupByFirstCountry = this.groupByFirstCountry.bind(this);

        // Functions to validate and submit form updates
        this.verifyProfileData = this.verifyProfileData.bind(this);
        this.verifyEmailData = this.verifyEmailData.bind(this);
        this.verifyPasswordData = this.verifyPasswordData.bind(this);
        this.submitProfileData = this.submitProfileData.bind(this);
        this.submitEmailData = this.submitEmailData.bind(this);
        this.submitPasswordData = this.submitPasswordData.bind(this);
        this.handleFileChangePicture = this.handleFileChangePicture.bind(this);
        this.updatePicture = this.updatePicture.bind(this);
    }


    async componentDidMount() {
        await this.props.setLoading("account_componentDidMount");
        var user_id = null;
        var username = null;
        var login = false;
        if (this.props.params.userid) {
            user_id = null;
            username = this.props.params.userid;
        }
        else if (this.props.login && this.props.user_id) {
            user_id = this.props.user_id
            login = true;
        } else {
            user_id = null;
            username = null;
        }
        user_id = parseInt(user_id);
        await this.setState({
            user_id: user_id,
            login: login
        });
        // Run API calls in parallel
        try {
            await Promise.all([
                this.loadUserData(user_id, username),
                this.loadUserTripData(user_id, username),
                this.props.login ? this.loadUserTripViewData(user_id, username) : Promise.resolve(),
                this.props.login ? this.loadUserTripUnlockData(user_id, username) : Promise.resolve(),
                this.props.login ? this.loadUserOrdersData(user_id) : Promise.resolve(),
                this.props.login ? this.loadUserCurrentBalance(user_id) : Promise.resolve(),
                this.props.login ? this.loadUserSalesData(user_id) : Promise.resolve(),
                this.props.login ? this.loadUserPayoutsData(user_id) : Promise.resolve()
            ]);
        } catch (error) {
        } finally {
            await this.props.unsetLoading("account_componentDidMount", true);
        }
    }


    async loadUserData(user_id, username = null) {
        try {
            var userdata = [];
            if (user_id) {
                userdata = getJSONLocalStorage(user_id + "_userdata", 1);
            }
            if (username) {
                userdata = getJSONLocalStorage(username + "_userdata", 1);
            }
            if (userdata && userdata.user_id && userdata.user_id.length > 0) {
                this.setState({
                    data: userdata
                });
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getuserdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id,
                    username: username
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data.user_id) {
                // Set data to state
                if (data.birthday) {
                    const birthday = data.birthday;
                    const parts = birthday.split('/');
                    const formattedDate = `${parts[2]}-${parts[0]}-${parts[1]}`;
                    data.birthday = formattedDate;
                }
                this.setState({
                    data: data
                });
                setJSONLocalStorage(data.user_id + "_userdata", data);
                setJSONLocalStorage(data.username + "_userdata", data);
            } else {
                // Set data to state
                this.setState({
                    missingdata: true
                });
                // Track error
                var name = "";
                var message = "Could not load user data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Set data to state
            this.setState({
                missingdata: true
            });
            // Track error
            var name = "";
            var message = "Could not load user data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_loadUserData");
        }
    }


    groupByFirstCountry(items, countriesKey = "countries") {
        const map = items.reduce((acc, item) => {
            const countries = item?.[countriesKey];
            const firstCountry = Array.isArray(countries) && countries.length > 0 ? countries[0] : "Unknown";

            // Option A: skip items without a first country
            if (!firstCountry) return acc;

            if (!acc.has(firstCountry)) {
                acc.set(firstCountry, { country: firstCountry, trips: [] });
            }
            acc.get(firstCountry).trips.push(item);
            return acc;
        }, new Map());

        // Convert grouped Map values to the requested array-of-dicts shape
        return Array.from(map.values());
    }


    async loadUserTripData(user_id, username = null) {
        try {
            var usertripdata = getJSONLocalStorage(user_id + "_usertripdata", 1);
            if (usertripdata && usertripdata.length > 0) {
                this.setState({
                    userTrips: usertripdata
                });
            }
            var usertripdatagrouped = getJSONLocalStorage(user_id + "_usertripdatagrouped", 1);
            if (usertripdatagrouped && usertripdatagrouped.length > 0) {
                this.setState({
                    userTripsGrouped: usertripdatagrouped
                });
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getusertrips", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id,
                    username: username
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                // Sort by updated
                const sortedData = data.sort((a, b) => {
                    const lastUpdatedA = (a.updated && a.updated.length > 0) ? new Date(a.updated[a.updated.length - 1]) : new Date(0);
                    const lastUpdatedB = (b.updated && b.updated.length > 0) ? new Date(b.updated[b.updated.length - 1]) : new Date(0);
                    return lastUpdatedB - lastUpdatedA; // Sort descending
                });
                const groupedData = this.groupByFirstCountry(sortedData);
                this.setState({
                    userTrips: sortedData,
                    userTripsGrouped: groupedData
                });
                setJSONLocalStorage(user_id + "_usertripdata", sortedData);
                setJSONLocalStorage(user_id + "_usertripdatagrouped", groupedData);
            } else {
                // Track error
                var name = "";
                var message = "Could not load user data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load user data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_loadUserTripData");
        }
    }


    async loadUserTripViewData(user_id) {
        try {
            var usertripviewdata = getJSONLocalStorage(user_id + "_usertripviewdata", 1);
            if (usertripviewdata && usertripviewdata.length > 0) {
                this.setState({
                    userTripViews: usertripviewdata
                });
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getusertripviews", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                this.setState({
                    userTripViews: data
                });
                setJSONLocalStorage(user_id + "_usertripviewdata", data);
            } else {
                // Track error
                var name = "";
                var message = "Could not load user data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load user data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_loadUserTripViewData");
        }
    }


    async loadUserTripUnlockData(user_id) {
        try {
            var usertripunlockdata = getJSONLocalStorage(user_id + "_usertripunlockdata", 1);
            if (usertripunlockdata && usertripunlockdata.length > 0) {
                this.setState({
                    userTripUnlocks: usertripunlockdata
                });
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getusertripunlocks", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                this.setState({
                    userTripUnlocks: data
                });
                setJSONLocalStorage(user_id + "_usertripunlockdata", data);
            } else {
                // Track error
                var name = "";
                var message = "Could not load user data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load user data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_loadUserTripUnlockData");
        }
    }


    async loadUserOrdersData(user_id) {
        try {
            var usersalesdata = getJSONLocalStorage(user_id + "_userordersdata", 1);
            if (usersalesdata && usersalesdata.length > 0) {
                this.setState({
                    userOrders: usersalesdata
                });
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getbuyerordersdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                this.setState({
                    userOrders: data
                });
                setJSONLocalStorage(user_id + "_userordersdata", data);
            } else {
                // Track error
                var name = "";
                var message = "Could not load order data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load order data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "account_loadUserOrdersData");
        }
    }


    async loadUserCurrentBalance(user_id) {
        try {
            var current_balance = getJSONLocalStorage(user_id + "_usercurrentbalance", 1);
            if (current_balance) {
                this.setState({
                    current_balance: parseFloat(current_balance)
                });
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getcreatorcurrentbalance", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                this.setState({
                    current_balance: parseFloat(data.balance)
                });
                setJSONLocalStorage(user_id + "_usercurrentbalance", parseFloat(data.balance));
            } else {
                // Track error
                var name = "";
                var message = "Could not load current balance. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load current balance. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "account_loadUserCurrentBalance");
        }
    }


    async loadUserSalesData(user_id) {
        try {
            var usersalesdata = getJSONLocalStorage(user_id + "_usersalesdata", 1);
            if (usersalesdata && usersalesdata.length > 0) {
                this.setState({
                    userSales: usersalesdata
                });
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getsellerordersdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                this.setState({
                    userSales: data
                });
                setJSONLocalStorage(user_id + "_usersalesdata", data);
            } else {
                // Track error
                var name = "";
                var message = "Could not load sales data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load sales data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "account_loadUserSalesData");
        }
    }


    async loadUserPayoutsData(user_id) {
        try {
            var usersalesdata = getJSONLocalStorage(user_id + "_userpayoutdata", 1);
            if (usersalesdata && usersalesdata.length > 0) {
                this.setState({
                    userSales: usersalesdata
                });
            }
            // Send request
            var response = await fetch(this.props.baseUrl + "/getcreatorpayoutsdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    user_id: user_id
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                this.setState({
                    userPayouts: data
                });
                setJSONLocalStorage(user_id + "_userpayoutdata", data);
            } else {
                // Track error
                var name = "";
                var message = "Could not load payout data. Please try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not load payout data. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "account_loadUserPayoutsData");
        }
    }


    async enableCreatorPayouts() {
        try {
            // Set loading
            this.props.setLoading("account_enableCreatorPayouts");
            // Send request
            var response = await fetch(this.props.baseUrl + "/enablecreatorpayouts", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                }
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data) {
                // Track event
                this.props.logEvent("User activity", "Creator payouts enabled");
                // Forward user to Stripe
                console.log(data.onboarding_url);
                window.location.href = data.onboarding_url;
                // Set loading
                /* this.props.unsetLoading("account_enableCreatorPayouts"); */
            } else {
                // Track error
                var name = "";
                var message = "Could not enable payouts. Please try again.";
                this.props.setError(name, message);
                this.props.unsetLoading("account_enableCreatorPayouts");
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not enable payouts. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "account_enableCreatorPayouts");
            this.props.unsetLoading("account_enableCreatorPayouts");
        }
    }


    setPage(page, trip_id = null) {
        this.setState({ page: page });
        if (trip_id) {
            this.setState({ trip_id: trip_id });
        }
    }


    setDataValue(label, value) {
        var data = this.state.data;
        data[label] = value;
        this.setState({ data: data });
    }


    setFormValue(label, value) {
        this.setState({ [label]: value });
    }


    addLocation(label, value) {
        console.log("addLocation", value);
        var data = this.state.data;
        console.log(data);
        if (!data.locations.includes(value)) {
            data.locations.push(value);
        }
        this.setState({ data: data });
    }


    removeLocation(value) {
        var data = this.state.data;
        data.locations = data.locations.filter(item => item !== value);
        this.setState({ data: data });
    }


    handleFileChangePicture(event) {
        this.setState({
            upload_image_file: event.target.files[0]
        });
    }


    async updatePicture() {
        this.props.setLoading("account_updatePicture");
        this.setState({ uploading: true });
        const file = this.state.upload_image_file;
        if (!file) {
            alert('Please select an image file');
            return;
        }

        try {
            // Step 1: Request a pre-signed URL for each file
            const payload = {
                file_name: file.name,
                file_type: file.type
            };
            const response = await fetch(this.props.baseUrl + "/createuploadurl", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify(payload)
            });
            // Handle response
            if (!response.ok) throw new Error(`Failed to get pre-signed URL for ${file.name}`);
            const jsonResponse = await response.json();
            const url = jsonResponse.value.link.url;
            const key = jsonResponse.value.link.key;
            if (!url || !key) {
                throw new Error(`Invalid pre-signed URL response for ${file.name}`);
            }
            // Step 2: Upload file to S3 using the pre-signed URL
            const uploadResponse = await fetch(url, {
                method: 'PUT',
                body: file,
                headers: { 'Content-Type': file.type }
            });
            if (!uploadResponse.ok) throw new Error(`Upload failed for ${file.name}`);
            // Step 3: Request processing of file
            const processResponse = await fetch(this.props.baseUrl + "/uploaduserpicture", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    file_key: key
                })
            });
            if (!processResponse.ok) throw new Error(`Processing failed for ${file.name}`);
            const data = await processResponse.json();
            // Update user data
            if (data.value.status == true) {
                // Track event
                this.props.logEvent("User activity", "User picture updated");
                this.setState({ upload_image_file: null });
                await this.loadUserData(this.state.user_id);
                this.setPage("");
                window.scrollTo(0, 0);
            }
            // Prepare response
            this.setState({ uploading: false });
            this.props.unsetLoading("account_updatePicture");
        } catch (error) {
            // Track error
            var name = "Client error";
            var message = "Could not upload picture.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_updatePicture");
            this.setState({ uploading: false });
            this.props.unsetLoading("account_updatePicture");
        }
    }


    verifyProfileData() {
        const data = this.state.data;
        var return_value = true;
        // Check if name is set
        if (!data.name || data.name == "" || data.name.length > 50) {
            var name = "Data error";
            var message = "Please provide your name with up to 50 characters.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        // Check if username is set
        if (!data.username || data.username == "" || data.username.length > 20) {
            var name = "Data error";
            var message = "Please provide a username with up to 20 characters.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        // Check if bio is set
        if (data.bio_description.length > 2000) {
            var name = "Data error";
            var message = "Please provide a bio with up to 2,000 characters.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        // Check if birthday is set
        if (data.birthday.length > 50) {
            var name = "Data error";
            var message = "Please provide a valid birthday.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        // Convert data format for birthday if needed
        if (data.birthday.includes("-")) {
            const birthday = data.birthday;
            const parts = birthday.split('-');
            const formattedDate = `${parts[1]}/${parts[2]}/${parts[0]}`;
            data.birthday = formattedDate;
            this.setState({ birthday: formattedDate });
        }
        // Check if country is set
        if (data.country.length > 50) {
            var name = "Data error";
            var message = "Please provide a valid country.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        // Check if country is set
        if (data.hometown.length > 100) {
            var name = "Data error";
            var message = "Please provide a valid hometown.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        // Check if country and hometown are properly set
        if (data.country == "" && data.hometown != "") {
            var name = "Data error";
            var message = "Please provide a validcountry.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        // Check if socials are set
        if (data.website.length > 100 || data.instagram.length > 100 || data.tiktok.length > 100 || data.youtube.length > 100 || data.linkedin.length > 100 || data.twitterx.length > 100 || data.snapchat.length > 100 || data.facebook.length > 100) {
            var name = "Data error";
            var message = "Please provide social account links with up to 100 characters.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        return return_value;
    }


    verifyEmailData() {
        const email = this.state.email;
        var return_value = true;
        // Check if name is set
        if (!email || email == "" || email.length > 100 || !this.validateEmail(email)) {
            var name = "Data error";
            var message = "Please provide a valid email.";
            this.props.setError(name, message);
            return_value = false;
            return return_value;
        }
        return return_value;
    }


    verifyPasswordData() {
        var return_value = true;
        // Check if name is set
        if (!this.state.password_old || this.state.password_old == "" || this.state.password_old.length < 5 || this.state.password_old.length > 50) {
            var name = "Data error";
            var message = "Please provide your old password.";
            this.props.setError(name, message);
            return_value = false;
        }
        if (!this.state.password_new || this.state.password_new == "" || this.state.password_new.length < 5 || this.state.password_new.length > 50) {
            var name = "Data error";
            var message = "Please provide a new password with 5 to 50 characters.";
            this.props.setError(name, message);
            return_value = false;
        }
        if (this.state.password_new != this.state.password_new_2) {
            var name = "Data error";
            var message = "Your passwords don't match.";
            this.props.setError(name, message);
            return_value = false;
        }
        return return_value;
    }


    validateEmail(email) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }


    async followUser(follow = true) {
        try {
            this.props.setLoading("account_followUser");
            if (this.props.login_user && this.state.data.user_id) {
                // Send request
                var response = await fetch(this.props.baseUrl + "/followuser", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${getToken()}`
                    },
                    body: JSON.stringify({
                        user_id: this.state.data.user_id,
                        follow: follow
                    }),
                });
                // Process response
                response = await response.json();
                var data = response.value;
                if (data.status == true) {
                    // Track event
                    this.props.logEvent("User activity", "Account followed");
                    this.loadUserData(this.state.data.user_id);
                    this.setPage("");
                    window.scrollTo(0, 0);
                } else {
                    // Track error
                    var name = "";
                    var message = "Could not update user data. Please try again later.";
                    this.props.setError(name, message);
                }
            }
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not update user data. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_followUser");
        } finally {
            this.props.unsetLoading("account_followUser");
        }
    }


    async submitProfileData() {
        try {
            this.props.setLoading("account_submitProfileData");
            const data_in = this.state.data;
            var status = this.verifyProfileData();
            if (status) {
                // Send request
                var response = await fetch(this.props.baseUrl + "/updateuserdata", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${getToken()}`
                    },
                    body: JSON.stringify({
                        data: data_in,
                        user_id: this.state.user_id
                    }),
                });
                // Process response
                response = await response.json();
                var data = response.value;
                if (data.status == true) {
                    // Track event
                    this.props.logEvent("User activity", "Account updated");
                    this.loadUserData(this.state.user_id);
                    this.setPage("");
                    window.scrollTo(0, 0);
                } else {
                    if (data.error == "username") {
                        // Track error
                        var name = "Error";
                        var message = "This username is already in use. Please choose a different username.";
                        this.props.setError(name, message);
                    } else {
                        // Track error
                        var name = "";
                        var message = "Could not update user data. Please try again later.";
                        this.props.setError(name, message);
                    }
                }
            }
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not update user data. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_submitProfileData");
        } finally {
            this.props.unsetLoading("account_submitProfileData");
        }
    }


    async submitEmailData() {
        try {
            this.props.setLoading("account_submitEmailData");
            if (this.verifyEmailData()) {
                // Send request
                var response = await fetch(this.props.baseUrl + "/updateuseremail", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${getToken()}`
                    },
                    body: JSON.stringify({
                        email: this.state.email,
                        user_id: this.state.user_id
                    }),
                });
                // Process response
                response = await response.json();
                var data = response.value;
                if (data.status == true) {
                    // Track event
                    this.props.logEvent("User activity", "Email updated");
                    this.loadUserData(this.state.user_id);
                    this.setPage("");
                    window.scrollTo(0, 0);
                } else {
                    if (data.error == "email") {
                        // Track error
                        var name = "Error";
                        var message = "This email is already in use. Please choose a different email.";
                        this.props.setError(name, message);
                    } else {
                        // Track error
                        var name = "";
                        var message = "Could not update email. Please try again later.";
                        this.props.setError(name, message);
                    }
                }
            }
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not update email. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_submitEmailData");
        } finally {
            this.props.unsetLoading("account_submitEmailData");
        }
    }


    async submitPasswordData() {
        try {
            this.props.setLoading("account_submitPasswordData");
            if (this.verifyPasswordData()) {
                // Send request
                var response = await fetch(this.props.baseUrl + "/updateuserpassword", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${getToken()}`
                    },
                    body: JSON.stringify({
                        password_old: this.state.password_old,
                        password: this.state.password_new,
                        user_id: this.state.user_id
                    }),
                });
                // Process response
                response = await response.json();
                var data = response.value;
                if (data.status == true) {
                    // Track event
                    this.props.logEvent("User activity", "Password updated");
                    this.loadUserData(this.state.user_id);
                    this.setPage("");
                    window.scrollTo(0, 0);
                } else {
                    if (data.error == "password") {
                        // Track error
                        var name = "Error";
                        var message = "You entered the wrong current password. Please try again.";
                        this.props.setError(name, message);
                    } else {
                        // Track error
                        var name = "";
                        var message = "Could not update password. Please try again later.";
                        this.props.setError(name, message);
                    }
                }
            }
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not update password. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Account_submitPasswordData");
        } finally {
            this.props.unsetLoading("account_submitPasswordData");
        }
    }


    render() {

        return (
            <div className="content-container">

                {this.state.login &&
                    <Helmet>
                        {/* Add the breadcrumb schema as JSON-LD */}
                        <script type="application/ld+json">
                            {`
                            {
                                "@context": "https://schema.org",
                                "@type": "BreadcrumbList",
                                "itemListElement": [
                                {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Home",
                                    "item": "https://guidr.net/"
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "Your account",
                                    "item": "https://guidr.net/account"
                                }
                                ]
                            }
                            `}
                        </script>
                        <title>{"Your account | Guidr"}</title>
                    </Helmet>
                }
                {(!this.state.login && this.state.data.username) &&
                    <Helmet>
                        {/* Add the breadcrumb schema as JSON-LD */}
                        <script type="application/ld+json">
                            {`
                            {
                                "@context": "https://schema.org",
                                "@type": "BreadcrumbList",
                                "itemListElement": [
                                {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Guidr Home",
                                    "item": "https://guidr.net/"
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "User: ${this.state.data.username}",
                                    "item": "https://guidr.net/u/${this.state.data.username}"
                                }
                                ]
                            }
                            `}
                        </script>
                        <title>{this.state.data.username + " | Guidr user"}</title>
                    </Helmet>
                }

                {(!this.state.data.user_id && this.state.missingdata) &&
                    <MissingPage />
                }
                {this.state.data.user_id &&
                    <div className="content-wrapper account-wrapper">
                        <div className="account__sidebar">
                            <div className="account__element account__picture-container">
                                {this.state.data.picture &&
                                    <img src={this.state.data.picture} alt={this.state.data.username} className={"account__element account__picture-inner"} />
                                }
                                {!this.state.data.picture &&
                                    <img src={this.state.sample_picture} alt={this.state.data.username} className={"account__element account__picture-inner"} />
                                }
                                {this.state.login &&
                                    <IconEdit onClick={() => this.setPage("edit_picture")} className="account__picture-icon" />
                                }
                            </div>

                            {(!this.state.login && this.props.login_user && this.state.data.username) &&
                                <div className="account__element">
                                    {!this.state.data.follow_status &&
                                        <div onClick={() => this.followUser(true)} className="account__contentbox button button-primary">
                                            Follow user
                                        </div>
                                    }
                                    {this.state.data.follow_status &&
                                        <div onClick={() => this.followUser(false)} className="account__contentbox button button-primary-light">
                                            Unfollow user
                                        </div>
                                    }
                                </div>
                            }

                            <div className="account__element">
                                {this.state.data.badges && this.state.data.badges.length >= 1 &&
                                    <div className="account__contentbox account__badges-container">
                                        {this.state.data.badges.map((badge, index) => (
                                            <div key={index} className="account__badges__badge">
                                                <img
                                                    src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/badges/" + badge + ".png"}
                                                    alt={badge}
                                                    className={"account__badges__badge-inner"}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                }
                                {this.state.data.username &&
                                    <div className="account__contentbox text-subtitle">
                                        {this.state.data.username}
                                    </div>
                                }
                                {this.state.data.username &&
                                    <div className="account__contentbox">
                                        {this.state.data.name}
                                        {(this.state.data.account_type && this.state.data.account_type != "") ? ", " + this.state.data.account_type : ""}
                                    </div>
                                }
                                {this.state.data.created &&
                                    <div className="account__contentbox text-color-grey">
                                        {"Member since " + format_month_year(this.state.data.created)}
                                    </div>
                                }
                                {(this.state.data.country || this.state.data.hometown) &&
                                    <div className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconLocation className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            {(this.state.data.hometown) + ((this.state.data.hometown && this.state.data.country) ? ", " : "") + (this.state.data.country)}
                                        </div>
                                    </div>
                                }
                                {this.state.data.locations && this.state.data.locations.length >= 1 &&
                                    <div className="account__contentbox text-color-grey">
                                        {`Travelled to ${this.state.data.locations.join(', ').replace(/, ([^,]*)$/, ', and $1')}`}
                                    </div>
                                }
                            </div>

                            {this.state.login &&
                                <div className="account__element">
                                    {this.state.userTrips.length >= 1 && this.state.page === "dashboard" && (!this.state.data.stripe_connect_account_id || !this.state.data.stripe_payouts_enabled) &&
                                        <div onClick={() => this.enableCreatorPayouts()} className="account__contentbox button button-secondary">
                                            Enable payouts
                                        </div>
                                    }
                                    {this.state.login &&
                                        <Link to="/createtrip" className="account__contentbox button button-primary">
                                            Create Trip
                                        </Link>
                                    }
                                    {this.state.userTrips.length >= 1 && this.state.login &&
                                        <div onClick={() => this.setPage("dashboard")} className="account__contentbox button button-primary">
                                            Creator dashboard
                                        </div>
                                    }
                                    {this.state.userTrips.length >= 1 && this.state.login &&
                                        <div onClick={() => this.setPage("trip_statistics")} className="account__contentbox button button-primary">
                                            Trip statistics
                                        </div>
                                    }
                                    {this.state.login && this.state.userOrders && this.state.userOrders.length >= 1 &&
                                        <div onClick={() => this.setPage("orders")} className="account__contentbox button button-primary">
                                            Your orders
                                        </div>
                                    }
                                    <div onClick={() => this.setPage("edit_profile")} className={"account__contentbox button " + (this.state.userTrips.length >= 1 ? "button-primary-light" : "button-primary")}>
                                        Edit profile
                                    </div>
                                    <div onClick={() => this.setPage("qrcode")} className="account__contentbox button button-primary-light">
                                        Profile QR code
                                    </div>
                                    <div onClick={() => this.setPage("change_email")} className="account__contentbox button button-primary-light">
                                        Change email
                                    </div>
                                    <div onClick={() => this.setPage("change_password")} className="account__contentbox button button-primary-light">
                                        Change password
                                    </div>
                                </div>
                            }

                            <div className="account__element">
                                {this.state.data.website != "" &&
                                    <a href={this.state.data.website} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconHome className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            Website
                                        </div>
                                    </a>
                                }
                                {this.state.data.instagram != "" &&
                                    <a href={this.state.data.instagram} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconInstagram className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            Instagram
                                        </div>
                                    </a>
                                }
                                {this.state.data.tiktok != "" &&
                                    <a href={this.state.data.tiktok} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconTiktok className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            TikTok
                                        </div>
                                    </a>
                                }
                                {this.state.data.snapchat != "" &&
                                    <a href={this.state.data.snapchat} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconLinkedin className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            Snapchat
                                        </div>
                                    </a>
                                }
                                {this.state.data.linkedin != "" &&
                                    <a href={this.state.data.linkedin} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconLinkedin className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            Linkedin
                                        </div>
                                    </a>
                                }
                                {this.state.data.twitterx != "" &&
                                    <a href={this.state.data.twitterx} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconTwitterx className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            X
                                        </div>
                                    </a>
                                }
                                {this.state.data.facebook != "" &&
                                    <a href={this.state.data.facebook} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconFacebook className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            Facebook
                                        </div>
                                    </a>
                                }
                                {this.state.data.youtube != "" &&
                                    <a href={this.state.data.youtube} className="account__contentbox account__contentbox--flex">
                                        <div className="account__contentbox__icon">
                                            <IconYoutube className="account__contentbox__icon-inner" />
                                        </div>
                                        <div className="account__contentbox__text">
                                            Youtube
                                        </div>
                                    </a>
                                }
                            </div>

                            {this.state.data.bio_description &&
                                <div className="account__element">
                                    {this.state.data.bio_description}
                                </div>
                            }

                        </div>

                        <div className="account__content-container">

                            {/* Overview */}
                            {this.state.page === "" &&
                                <div className="account__content">

                                    {this.state.login &&
                                        <div className="account__title-container text-title">
                                            <div className="account__title__element">
                                                Overview
                                            </div>
                                        </div>
                                    }

                                    {this.state.login &&
                                        <div className="account__section">
                                            {this.state.userTrips.length >= 1 && this.state.login &&
                                                <div className="account__element text-subtitle">
                                                    Your trips
                                                </div>
                                            }

                                            {this.state.userTrips.length < 1 && this.state.login &&
                                                <div className="account__element text-subtitle">
                                                    You don't have any trips yet
                                                </div>
                                            }

                                            {this.state.data && this.state.userTrips.length >= 1 && this.state.login &&
                                                <Tripcarousel
                                                    data={this.state.userTrips.length >= 1 ? this.state.userTrips.slice(0, 3) : []}
                                                />
                                            }

                                            {this.state.data && this.state.userTrips.length >= 1 &&
                                                <div className="account__element">
                                                    <div onClick={() => this.setPage("trips_mine")} className="account__element__link-container">
                                                        <span className="account__element__link__label">
                                                            See all
                                                        </span>
                                                        <IconLink className="account__element__link__icon" />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }

                                    {!this.state.login &&
                                        <div className="account__section">
                                            {this.state.userTrips.length >= 1 &&
                                                <div className="account__element text-subtitle">
                                                    Trips
                                                </div>
                                            }
                                            {this.state.userTrips.length < 1 &&
                                                <div className="account__element text-subtitle">
                                                    No trips available yet
                                                </div>
                                            }

                                            {this.state.userTrips && this.state.userTrips.length > this.TRIP_THRESHOLD && this.state.userTripsGrouped &&
                                                this.state.userTripsGrouped.map((country, index) => (
                                                    <div key={index} className="account__section">
                                                        <div className="account__element text-subtitle">
                                                            {country.country}
                                                        </div>
                                                        <Tripcarousel
                                                            data={country.trips.length >= 1 ? country.trips : []}
                                                        />
                                                    </div>
                                                ))
                                            }
                                            {((this.state.userTrips && this.state.userTrips.length >= 1) && (this.state.userTrips.length <= this.TRIP_THRESHOLD || !this.state.userTripsGrouped)) &&
                                                <div className="account__section">
                                                    <Tripcarousel
                                                        data={this.state.userTrips.length >= 1 ? this.state.userTrips : []}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    }

                                    {this.state.login && this.state.userTripUnlocks.length >= 1 &&
                                        <div className="account__section">
                                            <div className="account__element text-subtitle">
                                                Trips you follow
                                            </div>

                                            {this.state.data &&
                                                <Tripcarousel
                                                    data={this.state.userTripUnlocks.length >= 1 ? this.state.userTripUnlocks.slice(0, 3) : []}
                                                />
                                            }

                                            {this.state.userTripUnlocks.length >= 1 &&
                                                <div className="account__element">
                                                    <div onClick={() => this.setPage("trips_following")} className="account__element__link-container">
                                                        <span className="account__element__link__label">
                                                            See all
                                                        </span>
                                                        <IconLink className="account__element__link__icon" />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }

                                    {this.state.login && this.state.userTripViews.length >= 1 &&
                                        <div className="account__section">
                                            <div className="account__element text-subtitle">
                                                {/* Trips you follow */}
                                                Recently viewed trips
                                            </div>

                                            {this.state.data &&
                                                <Tripcarousel
                                                    data={this.state.userTripViews.length >= 1 ? this.state.userTripViews.slice(0, 3) : []}
                                                />
                                            }

                                            {this.state.userTripViews.length >= 1 &&
                                                <div className="account__element">
                                                    <div onClick={() => this.setPage("trips_viewed")} className="account__element__link-container">
                                                        <span className="account__element__link__label">
                                                            See all
                                                        </span>
                                                        <IconLink className="account__element__link__icon" />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }

                                    {/* this.state.login &&
                                    <div className="account__section">
                                        Travelers you follow
                                    </div>
                                 */}

                                </div>
                            }

                            {/* Edit profile page */}
                            {this.state.login && this.state.page === "edit_profile" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Edit profile
                                        </div>
                                    </div>

                                    <div className="account__section">
                                        <div className="account__element">
                                            <ForminputText
                                                name={"name"}
                                                label={"Name"}
                                                default_value={this.state.data.name}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>

                                        <div className="account__element">
                                            <ForminputText
                                                name={"username"}
                                                label={"Username"}
                                                default_value={this.state.data.username}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>

                                        <div className="account__element">
                                            <ForminputTextbox
                                                name={"bio_description"}
                                                label={"Your bio"}
                                                placeholder={"Tell use a bit about yourself"}
                                                default_value={this.state.data.bio_description}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={false}
                                            />
                                        </div>

                                        <div className="account__element">
                                            <ForminputDate
                                                name={"birthday"}
                                                label={"Birthday"}
                                                default_value={this.state.data.birthday}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={false}
                                            />
                                        </div>

                                        <div className="account__element">
                                            <ForminputDropdown
                                                name={"account_type"}
                                                label={"Account type"}
                                                list={["Traveler", "Local guide", "Travel influencer", "Travel agent", "Hotel", "Rental host", "Campground", "Tourism agency", "Restaurant", "Tour operator", "Other"]}
                                                default_value={this.state.data.account_type}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={false}
                                            />
                                        </div>

                                    </div>

                                    {this.props.locations &&
                                        <div className="account__section">
                                            <div className="account__element text-subtitle">
                                                Location
                                            </div>
                                            <div className="account__element">
                                                <ForminputDropdown
                                                    name={"country"}
                                                    label={"Country"}
                                                    placeholder={"Country you live in"}
                                                    list={this.props.locations ? Object.keys(this.props.locations) : []}
                                                    default_value={this.state.data.country}
                                                    setFormValue={this.setDataValue.bind(this)}
                                                    required={false}
                                                />
                                            </div>
                                            {this.state.data.country && this.state.data.country != "" &&
                                                <div className="account__element">
                                                    <ForminputDropdown
                                                        name={"hometown"}
                                                        label={"Hometown"}
                                                        placeholder={"City you live in"}
                                                        list={this.props.locations ? this.props.locations[this.state.data.country] : []}
                                                        default_value={this.state.data.hometown}
                                                        setFormValue={this.setDataValue.bind(this)}
                                                        required={false}
                                                    />
                                                </div>
                                            }
                                            <div className="account__element text-subtitle">
                                                Places you have been to
                                            </div>
                                            <div className="account__element">
                                                <ForminputDropdown
                                                    name={"locations"}
                                                    label={"Places you have been to"}
                                                    placeholder={"Country"}
                                                    list={this.props.locations ? Object.keys(this.props.locations) : []}
                                                    setFormValue={this.addLocation.bind(this)}
                                                    required={false}
                                                />
                                            </div>
                                            {this.state.data.locations && this.state.data.locations.length >= 1 &&
                                                <div className="trip__popup__element labelbar">
                                                    {this.state.data.locations.map((country, index) => (
                                                        <div key={index} onClick={() => this.removeLocation(country)} className="label">
                                                            {country}
                                                        </div>
                                                    ))}
                                                </div>
                                            }
                                        </div>
                                    }

                                    <div className="account__section">
                                        <div className="account__element text-subtitle">
                                            Social accounts
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"website"}
                                                label={"Personal website"}
                                                placeholder={"Link to your website"}
                                                default_value={this.state.data.website}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"instagram"}
                                                label={"Instagram"}
                                                placeholder={"Link to your social profile"}
                                                default_value={this.state.data.instagram}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"tiktok"}
                                                label={"Tiktok"}
                                                placeholder={"Link to your social profile"}
                                                default_value={this.state.data.tiktok}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"youtube"}
                                                label={"Youtube"}
                                                placeholder={"Link to your social profile"}
                                                default_value={this.state.data.youtube}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"linkedin"}
                                                label={"LinkedIn"}
                                                placeholder={"Link to your social profile"}
                                                default_value={this.state.data.linkedin}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"twitterx"}
                                                label={"X"}
                                                placeholder={"Link to your social profile"}
                                                default_value={this.state.data.twitterx}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"snapchat"}
                                                label={"Snapchat"}
                                                placeholder={"Link to your social profile"}
                                                default_value={this.state.data.snapchat}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"facebook"}
                                                label={"Facebook"}
                                                placeholder={"Link to your social profile"}
                                                default_value={this.state.data.facebook}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                    </div>

                                    {/* <div className="account__section">
                                        <div className="account__element text-subtitle">
                                            Bank account (only needed if you sell trips on Guidr)
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"bank_name"}
                                                label={"Bank name"}
                                                placeholder={"Name of your bank"}
                                                default_value={this.state.data.bank_name}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"bank_account_number"}
                                                label={"Account Number"}
                                                placeholder={"Your bank account number"}
                                                default_value={this.state.data.bank_account_number}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputText
                                                name={"bank_routing_number"}
                                                label={"Routing Number"}
                                                placeholder={"Your bank's routing number"}
                                                default_value={this.state.data.bank_routing_number}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputDropdown
                                                name={"bank_account_type"}
                                                label={"Account type"}
                                                placeholder={"Type of bank account"}
                                                list={["Checking", "Savings"]}
                                                default_value={this.state.data.bank_account_type}
                                                setFormValue={this.setDataValue.bind(this)}
                                                required={false}
                                            />
                                        </div>
                                    </div> */}

                                    <div className="account__section">
                                        <div className="account__element">
                                            <div onClick={this.submitProfileData} className="button button-primary">
                                                Save changes
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            }

                            {/* Update picture page */}
                            {this.state.login && this.state.page === "edit_picture" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Edit picture
                                        </div>
                                    </div>

                                    <div className="account__section">
                                        <div className="trip__popup__picture__add-container">
                                            <IconAdd className="trip__popup__picture__add" />
                                            {!this.state.upload_image_file && !this.state.uploading &&
                                                <input type="file" onChange={this.handleFileChangePicture} className="trip__popup__picture__add-input" />
                                            }
                                            {this.state.upload_image_file && !this.state.uploading &&
                                                <div onClick={this.updatePicture} className="trip__popup__picture__add-submit text-bold">
                                                    Upload
                                                </div>
                                            }
                                            {this.state.uploading &&
                                                <div className="trip__popup__picture__add-uploading text-bold">
                                                    Uploading...
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    {/* <div className="account__section">
                                    <div className="account__element">
                                        <div onClick={""} className="button button-primary">
                                            Save changes
                                        </div>
                                    </div>
                                </div> */}

                                </div>
                            }

                            {/* Access QR code */}
                            {(this.state.login && this.state.page === "qrcode" && this.state.data.username && this.state.data.username !== "") &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            QR code
                                        </div>
                                    </div>

                                    <div className="account__section">
                                        <QRcode
                                            url={this.props.webUrl + "/u/" + this.state.data.username}
                                            title={""}
                                            description={""}
                                        />
                                    </div>

                                </div>
                            }

                            {/* Creator dashboard page */}
                            {this.state.login && this.state.page === "dashboard" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Dashboard
                                        </div>
                                    </div>

                                    <Dashboard
                                        trips={this.state.userTrips}
                                        user_data={this.state.data}
                                        sales={this.state.userSales}
                                        payouts={this.state.userPayouts}
                                        current_balance={this.state.current_balance}
                                    />

                                </div>
                            }

                            {/* Trip dashboard page */}
                            {this.state.login && this.state.page === "trip_statistics" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Trip Statistics
                                        </div>
                                    </div>

                                    <Tripstatistics
                                        trips={this.state.userTrips}
                                        sales={this.state.userSales}
                                    />

                                </div>
                            }

                            {/* Your orders page */}
                            {this.state.login && this.state.page === "orders" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Orders
                                        </div>
                                    </div>

                                    <Orders
                                        orders={this.state.userOrders}
                                    />

                                </div>
                            }

                            {/* Change email page */}
                            {this.state.login && this.state.page === "change_email" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Change email
                                        </div>
                                    </div>

                                    <div className="account__section">
                                        <div className="account__element">
                                            <ForminputText
                                                name={"email"}
                                                label={"E-mail"}
                                                default_value={this.state.data.email}
                                                setFormValue={this.setFormValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                    </div>

                                    <div className="account__section">
                                        <div className="account__element">
                                            <div onClick={this.submitEmailData} className="button button-primary">
                                                Save changes
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            }

                            {/* Change password page */}
                            {this.state.login && this.state.page === "change_password" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Change password
                                        </div>
                                    </div>

                                    <div className="account__section">
                                        <div className="account__element">
                                            <ForminputPassword
                                                name={"password_old"}
                                                label={"Old password"}
                                                default_value={this.state.password_old}
                                                setFormValue={this.setFormValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputPassword
                                                name={"password_new"}
                                                label={"New password"}
                                                default_value={this.state.password_new}
                                                setFormValue={this.setFormValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                        <div className="account__element">
                                            <ForminputPassword
                                                name={"password_new_2"}
                                                label={"Confirm new password"}
                                                default_value={this.state.password_new_2}
                                                setFormValue={this.setFormValue.bind(this)}
                                                required={true}
                                            />
                                        </div>
                                    </div>

                                    <div className="account__section">
                                        <div className="account__element">
                                            <div onClick={this.submitPasswordData} className="button button-primary">
                                                Save changes
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            }

                            {/* Trips you follow page */}
                            {this.state.login && this.state.page === "trips_following" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Trips you follow
                                        </div>
                                    </div>

                                    {this.state.data &&
                                        <Tripcarousel
                                            data={this.state.userTripUnlocks}
                                        />
                                    }

                                </div>
                            }

                            {/* Trips you viewed page */}
                            {this.state.login && this.state.page === "trips_viewed" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        <div className="account__title__element">
                                            Recently viewed trips
                                        </div>
                                    </div>

                                    {this.state.data &&
                                        <Tripcarousel
                                            data={this.state.userTripViews}
                                        />
                                    }

                                </div>
                            }

                            {/* Your trips page */}
                            {this.state.login && this.state.page === "trips_mine" &&
                                <div className="account__content">
                                    <div className="account__title-container text-title">
                                        <div onClick={() => this.setPage("")} className="account__title__element">
                                            Overview
                                        </div>
                                        {this.state.userTrips.length >= 1 &&
                                            <div className="account__title__element">
                                                Your trips
                                            </div>
                                        }
                                        {this.state.userTrips.length < 1 &&
                                            <div className="account__title__element">
                                                You don't have any trips yet
                                            </div>
                                        }
                                    </div>

                                    {this.state.userTrips && this.state.userTrips.length > this.TRIP_THRESHOLD && this.state.userTripsGrouped &&
                                        this.state.userTripsGrouped.map((country, index) => (
                                            <div key={index} className="account__section">
                                                <div className="account__element text-subtitle">
                                                    {country.country}
                                                </div>
                                                <Tripcarousel
                                                    data={country.trips}
                                                />
                                            </div>
                                        ))
                                    }
                                    {((this.state.userTrips && this.state.userTrips.length <= this.TRIP_THRESHOLD) || !this.state.userTripsGrouped) &&
                                        <div className="account__section">
                                            <Tripcarousel
                                                data={this.state.userTrips}
                                            />
                                        </div>
                                    }

                                </div>
                            }

                        </div>

                    </div>
                }
            </div>
        )
    }
}

export default withRouter(Account);